export const uuid = () => {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}

	return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
		s4() + '-' + s4() + s4() + s4();
};


// WEBPACK FOOTER //
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/common/uuid.ts